import { __awaiter } from "tslib";
import { SystemHeaderFilter } from './SystemHeaderFilter';
import { SharedConstants } from '@formbird/types';
import { cloneDeep } from 'lodash';
import * as jsonPatch from 'rfc6902';
const logger = console;
// let jsonPatch;
export class DocumentUpdater {
    /**
     * do any functions that are specific to a system type like clearing the document from the cache
     * @param document the document
     * @param updateDoc the updateDoc
     */
    static performSystemTypeUpdateOperations(document, updateDoc) {
        if (document.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_ACCOUNT && !updateDoc.pass) {
            updateDoc.pass = document.pass;
        }
    }
    /**
     * simple update - non deep
     * @param document the document
     * @param updateDoc the updateDoc
     */
    static applyUpdatesSimple(document, updateDoc) {
        if (updateDoc) {
            // perform any operations specific to a systemType
            DocumentUpdater.performSystemTypeUpdateOperations(document, updateDoc);
            // set the values in the updateDoc in the existing currentDocument
            const updateKeys = Object.keys(updateDoc);
            for (let i = 0; i < updateKeys.length; i++) {
                const fieldName = updateKeys[i];
                if (fieldName === 'systemHeader') {
                    SystemHeaderFilter.applyUpdatesToSystemHeader(document, updateDoc);
                }
                else {
                    document[fieldName] = updateDoc[fieldName];
                }
            }
        }
    }
    // get the updates by comparing the doc and original doc
    static getUpdates(originalDoc, doc) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.info('Determining fields that have changed in update');
            const changes = originalDoc ? jsonPatch.createPatch(originalDoc, doc) : [];
            return {
                updates: changes,
                documentId: doc.documentId
            };
        });
    }
    static applyUpdates(document, updateData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateData.updates) {
                jsonPatch.applyPatch(document, updateData.updates);
            }
        });
    }
    static applyUpdatesDeepDiff(document, updateDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            SystemHeaderFilter.applyUpdatesToSystemHeader(document, updateDoc);
            if (updateDoc.systemHeader) {
                updateDoc.systemHeader = cloneDeep(document.systemHeader);
            }
            // perform any operations specific to a systemType
            DocumentUpdater.performSystemTypeUpdateOperations(document, updateDoc);
            const updates = yield DocumentUpdater.getUpdates(document, updateDoc);
            yield DocumentUpdater.applyUpdates(document, updates);
        });
    }
}
